module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8"
  }, [_c('span', {
    staticClass: "copyright"
  }, [_vm._v(_vm._s(_vm.config.SITE_TITLE) + "   © 2017" + _vm._s(_vm.anoAtual()) + " - Todos os direitos reservados")])]), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-4 brand"
  }, [_vm._v("Desenvolvido pela"), _c('a', {
    staticClass: "sinfo",
    attrs: {
      "href": "http://info.ufrn.br/",
      "title": "Ir para o site da SINFO",
      "target": "_blank",
      "noopener": "noopener"
    }
  }, [_vm._v("SINFO")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27b18fde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/layouts/PageFooter.vue
// module id = 471
// module chunks = 0